import { injectable } from "inversify";
import GetCurrentLanguageUseCase, { GetCurrentLanguageUseCaseName } from "../localization/GetCurrentLanguageUseCase";
import di from "../../../dependency_injection";
import GetCurrentUserUseCase, { GetCurrentUserUseCaseName } from "../auth/GetCurrentUserUseCase";
import LoadThemeUseCase, { LoadThemeUseCaseName } from "../settings/load_theme.use_case";

interface Props {
}
@injectable()
export default class LoadUseCase {

    constructor(_props: Props) {
    }

    public call = async (): Promise<void> => {
        await Promise.all([
            di.get<GetCurrentLanguageUseCase>(GetCurrentLanguageUseCaseName).call(true),
            di.get<GetCurrentUserUseCase>(GetCurrentUserUseCaseName).call(),
            di.get<LoadThemeUseCase>(LoadThemeUseCaseName).call(),
        ]);
    }
}

export const LoadUseCaseName = "LoadUseCase";